import { FC, ReactNode } from 'react'
import { Typography } from '@mui/material'
import { typeScale } from '@/shared/styles/typography'

/** 「それでも解決しないとき」冒頭の連絡先 1 段落。variant が文言を持つ */
export const ContactNote: FC<{ children: ReactNode }> = ({ children }) => (
  <Typography sx={{ ...typeScale.body, my: 1 }}>{children}</Typography>
)
